<script>
import config from "@/helpers/config"
import niceFunctions from "@/helpers/niceFunctions"
import SvgTransition from '@/components/SvgTransition.vue'
export default {
    components: { SvgTransition },
    created() {  
        this.$cache.createCache('publicPage', 'public-page/',  {id: this.$route.params.id, domain: window.location.hostname });      
       
    },
    computed: {
        url() { return config.urlToServer },  
        publicPageColorsDict() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColorsDict : null },    
        tabs() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.tabs : null },   
        publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : null },
        height() { return window.innerHeight/1.14 + 'px' },
        tab() { return this.tabs.find(x => x.id == this.$route.params.tabid) },        
        publicPageImages() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageImages : null },
    }
}
</script>
<template>
   <section v-if="tabs != null && tab" v-fade-in>
        <div class="top-public position-relative" :style="{'height': height }" v-background="publicPageImages.find(x => x.location == 'tab_' + tab.id)">
            <SvgTransition :publicPage="publicPage"></SvgTransition>   
        </div>
        <div class="public-page">
            <div class="text-section">
                <h1 :style="publicPageColorsDict.header_color_on_white_bg.style">{{ tab.name }}</h1>
                <div v-html="this.$adaptHtml.adaptHtml(tab.text, publicPageColorsDict.header_color_on_white_bg, publicPageColorsDict.background_color.color)"></div>
            </div>
        </div>
   </section>
</template>
<style scoped>
    section {
        color: black;
    }
</style>